import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminCategories.css';

const AdminCategories = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      const response = await axios.get(`${apiUrl}/api/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setCategories(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('adminToken');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      const response = await axios.post(`${apiUrl}/api/categories`, newCategory, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setCategories([...categories, response.data]);
      setNewCategory({ name: '', description: '' });
    } catch (err) {
      setError(err.message);
    }
  };

  const handleUpdate = async (id, updatedCategory) => {
    try {
      const token = localStorage.getItem('adminToken');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      const response = await axios.put(`${apiUrl}/api/categories/${id}`, updatedCategory, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setCategories(categories.map(cat => cat._id === id ? response.data : cat));
      setEditingId(null);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Da li ste sigurni da želite da obrišete ovu kategoriju?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      await axios.delete(`${apiUrl}/api/categories/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setCategories(categories.filter(cat => cat._id !== id));
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <div className="admin-loading">Učitavanje...</div>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-title">Upravljanje kategorijama</h2>
      
      {error && <div className="admin-error">{error}</div>}

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-group">
          <label htmlFor="name">Naziv kategorije</label>
          <input
            type="text"
            id="name"
            value={newCategory.name}
            onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Opis</label>
          <textarea
            id="description"
            value={newCategory.description}
            onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
          />
        </div>
        <button type="submit" className="admin-button">Dodaj kategoriju</button>
      </form>

      <div className="categories-list">
        <table>
          <thead>
            <tr>
              <th>Naziv</th>
              <th>Opis</th>
              <th>Akcije</th>
            </tr>
          </thead>
          <tbody>
            {categories.map(category => (
              <tr key={category._id}>
                <td>
                  {editingId === category._id ? (
                    <input
                      type="text"
                      value={category.name}
                      onChange={(e) => setCategories(categories.map(cat =>
                        cat._id === category._id ? { ...cat, name: e.target.value } : cat
                      ))}
                    />
                  ) : (
                    category.name
                  )}
                </td>
                <td>
                  {editingId === category._id ? (
                    <textarea
                      value={category.description}
                      onChange={(e) => setCategories(categories.map(cat =>
                        cat._id === category._id ? { ...cat, description: e.target.value } : cat
                      ))}
                    />
                  ) : (
                    category.description
                  )}
                </td>
                <td>
                  <div className="admin-actions">
                    {editingId === category._id ? (
                      <>
                        <button
                          onClick={() => handleUpdate(category._id, category)}
                          className="admin-button small success"
                        >
                          Sačuvaj
                        </button>
                        <button
                          onClick={() => setEditingId(null)}
                          className="admin-button small"
                        >
                          Otkaži
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => setEditingId(category._id)}
                          className="admin-button small"
                        >
                          Izmeni
                        </button>
                        <button
                          onClick={() => handleDelete(category._id)}
                          className="admin-button small danger"
                        >
                          Obriši
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCategories; 